export default function convertAge(year, month = null, day = null) {
    if(year == null) return null;
    if(!month & !day) {
        const birth = year.split('-');
        year = birth[0];
        month = birth[1];
        day = birth[2];
    }

    var dateNow = new Date(),
        yearNow = dateNow.getFullYear(),
        monthNow = dateNow.getMonth() + 1,
        dayNow = dateNow.getDate(),
        age = yearNow - year;

    if ((monthNow < Number(month) || (monthNow === Number(month) && dayNow < Number(day)))) {
        age--;
    }

    return age;
}